import { createContext, useContext, useRef, Suspense } from "react";
import { useSetRecoilState } from "recoil";
import Cookies from "js-cookie";
import axios from "axios";
import { authState } from "../recoil";
import { _TEST1234, handleMovePage } from "../config/ApiConfig";
import { defaultAuthState } from "../recoil/authState";

const Context = createContext<any>(null);

const addAuthorization = async (ref: any) => {
    try {
        const path = `/api/v1/${_TEST1234.PORTAL_TYPE}/comn/login/usrInfo`;
        let ori = _TEST1234.PORTAL_API_ORI as string;
        if (_TEST1234.SYSTEM_GROUP_ORI === "tanoga") {
            ori = process.env.REACT_APP_API_OSCI as string;
        }
        // const { data, headers } = await axios.get(_TEST1234.PORTAL_API_ORI + path, {
        const { data, headers } = await axios.get(ori + path, {
            headers: {
                SystemGroup: _TEST1234.SYSTEM_GROUP_ORI,
                Authorization: `Bearer ${_TEST1234.AUTHORIZATION}`,
                RefreshAuthorization: `Bearer ${_TEST1234.REFRESH_AUTHORIZATION}`,
            },
            validateStatus: (status) => {
                return status <= 301 || status === 403;
            },
        });
        const userInfo = data.userInfo.content;
        window.sessionStorage.setItem("user-info", JSON.stringify(userInfo));
        ref.current.setAuth({
            userInfo,
            type: userInfo.lgnTp,
            coUsrYn: userInfo.coUsrYn,
            signedAt: userInfo.xpirDt,
            isSignedIn: userInfo.lgnTp !== "ANY",
            isInitialized: true,
        });

        // !== 이동 처리는 ApiConfig 의 handleMovePage 한 곳으로 모은다(정지 계정 분기 포함). ==!
        handleMovePage(headers["movepage"]);
    } catch (error) {
        throw new Error();
    }
};

const removeAuthorization = async () => {
    window.sessionStorage.removeItem("user-info");
    Cookies.remove("authorization");
    Cookies.remove("refreshauthorization");
    // link token 삭제 추가
    if (process.env.NODE_ENV === "development") {
        const systemGroup = process.env.REACT_APP_SYSTEM_GROUP || "";
        Cookies.remove(`authorization_${systemGroup}`);
        Cookies.remove(`refreshauthorization_${systemGroup}`);
    }
};

const promise = (ref: any) => {
    return new Promise<void>(async (resolve) => {
        try {
            if (_TEST1234.AUTHORIZATION) {
                await addAuthorization(ref);
            } else {
                throw new Error();
            }
        } catch (error) {
            await removeAuthorization();
            ref.current.setAuth({
                ...defaultAuthState,
                isInitialized: true,
            });
        } finally {
            ref.current.status = "fulfilled";
            resolve();
        }
    });
};

const AppFetcher = ({ children }: any) => {
    const { ref } = useContext(Context);
    switch (ref.current.status) {
        case "fulfilled":
            return children;
        // throw ref.current.promise;
        default:
            throw ref.current.promise;
    }
};

const AppSuspenser = ({ children }: any) => {
    return <Suspense fallback={<div></div>}>{children}</Suspense>;
};

const AppContextProvider = ({ children }: any) => {
    if (process.env.NODE_ENV === "development") console.log("App Context");

    const setAuth = useSetRecoilState(authState);
    const ref = useRef<any>({});
    if (!ref.current.done) {
        ref.current.done = true;
        ref.current.isInitialized = false;
        ref.current.status = "pending";
        ref.current.setAuth = setAuth;
        ref.current.promise = promise(ref);
    }
    return <Context.Provider value={{ ref }}>{children}</Context.Provider>;
};

const AppContext = {
    Provider: AppContextProvider,
    Suspenser: AppSuspenser,
    Fetcher: AppFetcher,
};

export default AppContext;
